import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { map, truncate } from 'lodash-es';
import { ContentLoader, MobileCardRowsProps } from '@dev/ee-components';
import { SimpleLandingCheckout } from '@dev/ee-api/ee-api-models';

import { getCheckoutsStore } from '@/store/checkouts/actions';
import { StatusBadge } from '@/assets/StatusBadge';
import { useCheckoutParamsFromUrl } from '@/components/Checkouts/hooks/useRequestParams';

const TitleWrapper = styled.div`
    word-break: break-all;
`;

export const useMobileTableRows = (): MobileCardRowsProps[] => {
    const { t } = useTranslation();
    const checkouts = useSelector(getCheckoutsStore);
    const params = useCheckoutParamsFromUrl();

    const SkeletonTemplate = {
        tableTitle: <ContentLoader mode="row" />,
        status: <ContentLoader mode="row" />,
    };

    const SkeletonRows = new Array(params?.limit).fill(SkeletonTemplate);
    
    const rows = map(
        checkouts?.templatesList,
        (checkout: SimpleLandingCheckout): MobileCardRowsProps => ({
            tableTitle: <TitleWrapper>{truncate(checkout.Name, { length: 45 })}</TitleWrapper>,
            Status: <StatusBadge status={checkout.Status} value={checkout.Status} />,
            returnOnItemClick: checkout as any,
            rowButtonText: t('viewoptions'),
        })
    );
    return checkouts.loadingTemplates ? SkeletonRows : rows;
};
